export enum AlertTypes {
  info = 'info',
  danger = 'danger',
  warning = 'warning',
  success = 'success',
}
